import { Carousel, ExternalLink, Image, Text } from "@sundae/ui-toolkit";
import { FC } from "react";
import { useTasteTestContext } from "../../../pages/TasteTestDetail/context";
import FadeInBasic from "../../FadeInView/FadeInBasic";
const {
  theme: { colors },
} = require("@sundae/tailwind-config");

const defaultPrimaryColor = colors.primary["DEFAULT"];

const TasteTestProjectPartners: FC = () => {
  const itemsPerSlide = 2;
  const {
    state: { tasteTest, tasteTestPersonalization },
  } = useTasteTestContext();
  const partners = tasteTest?.projectDetails.partners;

  return (
    <FadeInBasic
      style={{
        color: tasteTestPersonalization?.primaryColor ?? defaultPrimaryColor,
      }}
    >
      <Carousel
        arrows
        dots
        autoplay
        loop
        itemsPerSlide={itemsPerSlide}
        items={
          partners?.map(({ logo, name, type, url }, index) => {
            return (
              <FadeInBasic
                key={`${name}-${index}`}
                transitionDelay={
                  // Set 0 for the first item _per_ slide, 125ms for the rest
                  index % itemsPerSlide === 0 ? 0 : 125
                }
              >
                <ExternalLink
                  href={url}
                  className="flex min-h-[235px] w-fit flex-col items-center gap-2 text-center"
                >
                  <Image
                    className="h-full max-h-40 w-auto !rounded-lg drop-shadow-lg"
                    src={logo}
                    alt={`${name} logo`}
                    width={600}
                    height={400}
                  />
                  <div className="flex flex-col gap-1">
                    <Text tag="span" weight="medium" size="sm">
                      {name}
                    </Text>
                    {type && (
                      <Text tag="span" size="xs" variant="silent">
                        {type}
                      </Text>
                    )}
                  </div>
                </ExternalLink>
              </FadeInBasic>
            );
          }) || []
        }
      />
    </FadeInBasic>
  );
};

export default TasteTestProjectPartners;
